export function init() {
    const uppyEl = document.getElementById('uppy');
    if (!uppyEl || uppyEl.querySelector('.uppy-Root'))
        return;

    let btSubmit = null;
    const uppy = new Uppy.Uppy({
        locale: Uppy.locales.fr_FR,
        autoProceed: false,
        restrictions: {
            maxFileSize: (1024 ** 3) * 10,
            maxNumberOfFiles: 1,
            allowedFileTypes: ['.zip']
        }
    }).use(Uppy.Dashboard, {
        inline: true,
        theme: 'dark',
        hideUploadButton: true,
        target: '#uppy',
        width: '100%',
        height: 200,
    }).use(Uppy.Tus, {
        endpoint: '/tus/files',
        chunkSize: 80 * 1024 * 1024,
        headers: {
            'X-CSRFToken': document.querySelector('[name=csrfmiddlewaretoken]').value,
        }
    });

    uppy.on('upload-success', (file, response) => {
        document.getElementById('id_sources-0-tempFileId').value = response.uploadURL.split("+")[0].split("/")[5];
        Swal.fire({
            title: "{% trans 'Presque fini... Juste un instant !' %}",
            timerProgressBar: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });
        btSubmit.dispatchEvent(new Event("uppyFinish"));
    });

    uppy.on('upload-error', (file, response) => {
        Swal.fire({
            text: CONFIG.i18n.UPLOAD_FAILED,
            icon: "error"
        });
    });

    document.getElementById('form-challenge').addEventListener('submit', function (e) {
        e.preventDefault();
        btSubmit = e.target;
        if (uppy.getFiles().length > 0) {
            document.getElementById('uppy').scrollIntoView({behavior: 'smooth', block: 'start'});
            uppy.upload();
        } else {
            btSubmit.dispatchEvent(new Event("uppyFinish"));
        }
    });
}